import { connect } from 'react-redux';

import LearningModuleCardShort from '../components/LearningModuleCardShort';
import Format from '../../../../../lib/Format';
import {
  getImageSignedURL,
  setActiveImage,
} from '../../../../../state/modules/media/actions';

const mapStateToProps = (state, ownProps) => {
  const coverImage = ownProps.item?.cover_image ?? null;
  const sizeWidth = 329;
  const sizeHeight = 159;

  const imagePath = Format.buildImagePath(
    'ratio',
    sizeWidth,
    sizeHeight,
    coverImage
  );
  const imageUrl = state.media.getIn(['images', imagePath]) ?? null;

  const activeId = state.careGuides.get('activeId');
  return {
    activeId,

    imagePath: imagePath,
    imageUrl: imageUrl,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSignedUrl: (path, cb) => {
      dispatch(getImageSignedURL(path, cb));
    },
    setActiveImage: (imageUrl, imagePath) => {
      dispatch(setActiveImage(imageUrl, imagePath));
    },
  };
};

const LearningModuleCardShortContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningModuleCardShort);

export default LearningModuleCardShortContainer;
